export interface GroupablePage {
  id: string;
  pdfUploadId?: string | null;
}

export interface PdfPageGroup<T extends GroupablePage> {
  key: string;
  pages: T[];
}

// Collapses a flat, already-ordered list of report pages into one entry per
// uploaded PDF (all pages sharing the same pdfUploadId), so the grid can
// show a single "document" card instead of one card per page. A page with
// no pdfUploadId (uploaded before that column existed, or a non-PDF
// screenshot) becomes its own single-page group, keyed by its own id.
export function groupPdfPages<T extends GroupablePage>(pages: T[]): PdfPageGroup<T>[] {
  const order: string[] = [];
  const groups = new Map<string, T[]>();

  for (const page of pages) {
    const key = page.pdfUploadId || page.id;
    if (!groups.has(key)) {
      groups.set(key, []);
      order.push(key);
    }
    groups.get(key).push(page);
  }

  return order.map((key) => ({ key, pages: groups.get(key) }));
}
